export const LEGAL_LAYOUT_RETURN_PATH_KEY = 'return_path';
